Whether there is a previous page of results at the time of retrieval.
